// = Libs =
import React, { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './label.module.scss';

// = Types =
import { LabelProps } from './label.types';

const Label: FC<LabelProps> = (props) => {
  const { text = '', color = 'warning' } = props;

  return (
    <span
      className={clsx({
        [classes.label]: true,
        [classes[`label--${color}`]]: color,
      })}>
      {text}
    </span>
  );
};

export default Label;
